import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class CustomValidators {
  public static greaterThan(compareValue: number): ValidatorFn {
    return (formControl: FormControl<number>) => {
      if (formControl.value || formControl.value === 0) {
        return formControl.value > compareValue ? null : { greaterThan: true };
      }
      return null;
    };
  }

  public static notEqual(compareValue: number): ValidatorFn {
    return (formControl: FormControl<number>) => {
      if (formControl.value || formControl.value === 0) {
        return formControl.value !== compareValue ? null : { notEqual: true };
      }
      return null;
    };
  }

  public static required(control: AbstractControl): ValidationErrors | null {
    // Check control is a string that can be trimmed
    if (control.value && control.value.trim) {
      return control.value.trim() === '' ? { required: true } : null;
    }

    // Not a string, use default required Validators
    return Validators.required(control);
  }
}
